import React from 'react'

export const Title = ({title}={}) => {
  return (
        <h1 className='titles'>{title}</h1>
  )
}
